/** Import wizard copy, English only (one strings file per area, as in the shell). */
export const t = {
  title: "Import your members",
  intro: "Bring your gym's members, plans, dues and fingerprint ids over from your old software. Nothing is written until the owner signs off and you cut over.",
  listTitle: "Imports",
  empty: { title: "No imports yet", body: "Download a template to start." },
  start: "Start an import",
  newTitle: "New import",
  label: "Name this import",
  labelHint: "For example “Members from old software”.",
  branch: "Branch for imported members",
  branchHint: "Members, leads and opening bills are placed here unless the sheet says otherwise.",
  onError: "If a row has a problem",
  skipRows: "Skip that row and tell me (recommended)",
  abort: "Stop the whole import",
  create: "Create import",
  resume: "Continue",
  conflict: "Someone else changed this import. Reload.",
  reload: "Reload",
  notFound: { title: "Import not found", body: "It may belong to another gym, or it was removed." },
  cancel: { button: "Cancel import", title: "Cancel this import?", body: "The uploaded sheets are deleted and nothing is written to your gym. You can start a new import any time.", confirm: "Cancel import", keep: "Keep it" },
  cancelled: { title: "This import was cancelled", body: "Nothing was written to your gym." },
  steps: {
    upload: { title: "Add your sheets", body: "Pick what the sheet holds, then choose the file. CSV and Excel both work. The file is read here and sent as rows." },
    mapping: { title: "Match the columns", body: "Helmr suggested a match for each column. Check them, change any that are wrong, then save." },
    check: { title: "Check the data", body: "Helmr reads every row and tells you what it would do. Nothing is written yet." },
    review: { title: "Read the report", body: "Counts are what the cutover will write." },
    rehearse: { title: "Rehearse in a copy", body: "The whole import runs against a throwaway copy of your gym. Your real data is not touched." },
    signoff: { title: "Owner sign-off", body: "The owner approves exactly this plan. If anything changes, the plan changes and sign-off is needed again." },
    cutover: { title: "Cut over", body: "Writes the import into your live gym. Pick a quiet time." },
  },
  entities: { members: "Members (one wide sheet)", memberships: "Membership plans", dues: "Dues", pt_balances: "PT balances", leads: "Leads", staff: "Staff", device_users: "Fingerprint ids" } as Record<string, string>,
  entityHint: { members: "One row per person. May also carry plan, due, PT and fingerprint columns.", memberships: "One row per plan a member holds.", dues: "One row per amount a member owes.", pt_balances: "One row per PT pack with sessions left.", leads: "People who enquired but have not joined.", staff: "Your team. Roles are matched after the check.", device_users: "The id each person has on the fingerprint reader." } as Record<string, string>,
  template: "Download template",
  upload: "Choose file",
  uploading: "Uploading…",
  replace: "Replace",
  noSheets: "No sheets added yet.",
  tooBig: "That file is too large.",
  mappedAll: "Every sheet is matched.",
  rows: (n: number) => `${n.toLocaleString("en-IN")} row${n === 1 ? "" : "s"}`,
};
